import React, { useState, useEffect } from "react";
import "./EndClientCard.css";
import { FaUser } from "react-icons/fa";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
} from "@mui/material";
import { Close } from "../../Icons/Close";
import { ProfileIcon } from "../../Icons/profileIcon";

const EndClientCard = ({ client, onEdit }) => {
  const { name, location, status, notes, hiringManagers } = client;
  const [openPopup, setOpenPopup] = useState(false);
  const [theme, setTheme] = useState(null);

  const hiringManagersCount = hiringManagers?.length || 0;

  const handleOpenPopup = (e) => {
    e.stopPropagation();
    setOpenPopup(true);
  };
  const handleClosePopup = (e) => {
    if (e) e.stopPropagation();
    setOpenPopup(false);
  };

  useEffect(() => {
      const storedTheme = localStorage.getItem("themeSettings");
      if (storedTheme) {
        setTheme(JSON.parse(storedTheme));
      }
    }, []);

  return (
    <div className="end-client-card" onClick={onEdit}>
      <div className="card-header">
        <div className="header-info">
          <h3 className="client-name">{name}</h3>
          <p className="client-location">
            <img
              src={process.env.PUBLIC_URL + "/assests/img/locationGrey.svg"}
              alt="location"
            />{" "}
            {location}
          </p>
        </div>
        <div
          className={`endclient-status-badge ${status === 1 ? "active" : "inactive"}`}
        >
          {status === 1 ? "Active" : "Inactive"}
        </div>
      </div>
      <div className="card-body">
        {notes ? (
          <div
            className="client-notes"
            dangerouslySetInnerHTML={{ __html: notes }}
          ></div>
        ) : (
          <div className="client-notes">-</div>
        )}
        <div className="divider"></div>
        <div className="hiring-manager-section">
          <p className="section-title">
            HIRING MANAGER ({hiringManagersCount})
          </p>
          {hiringManagersCount === 0 ? (
            <p className="no-manager">No Hiring Manager Assigned</p>
          ) : hiringManagersCount === 1 ? (
            <div className="manager-info">
              <div className="manager-avatar">
                <ProfileIcon
                  primaryColor={theme?.primaryColor}
                  primaryFontColor={theme?.primaryFontColor}
                />
              </div>
              <div className="manager-details">
                <p className="manager-name">
                  {hiringManagers[0].hiringManagerName}
                </p>
                <p className="manager-role">{hiringManagers[0].jobTitle}</p>
              </div>
            </div>
          ) : (
            <button className="view-all-btn" onClick={handleOpenPopup}>
              View all {hiringManagersCount} Hiring Managers
            </button>
          )}
        </div>
      </div>

      <Dialog
        open={openPopup}
        onClose={handleClosePopup}
        maxWidth="xs"
        fullWidth
        onClick={(e) => e.stopPropagation()}
        PaperProps={{
          style: {
            borderRadius: "12px",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle className="popup-header">
          <span>Hiring Manager</span>
          <IconButton
            aria-label="close"
            onClick={(e) => handleClosePopup(e)}
            sx={{ color: "#ff4d4f", width: "30px", height: "30px" }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ padding: 0 }}>
          <Box className="popup-manager-list">
            {hiringManagers?.map((manager, index) => (
              <React.Fragment key={manager.id || index}>
                <div className="popup-manager-item">
                  <div className="manager-avatar">
                    <ProfileIcon
                      primaryColor={theme?.primaryColor}
                      primaryFontColor={theme?.primaryFontColor}
                    />
                  </div>
                  <div className="manager-details">
                    <p className="manager-name">{manager.hiringManagerName}</p>
                    <p className="manager-role">{manager.jobTitle}</p>
                  </div>
                </div>
                {index < hiringManagers.length - 1 && (
                  <div className="popup-divider"></div>
                )}
              </React.Fragment>
            ))}
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default EndClientCard;
